import LandingPageForm from '../components/LandingPageForm';

export default function MobileLandingPage() {
  return (
    <LandingPageForm 
      cityName="Los Angeles County"
      neighborhood="Los Angeles County"
      sourceTag="qr-truck-wrap"
      headline="Spotted Our Crew in Your Neighborhood? Get a Free Property Assessment."
      description="Professional exterior property maintenance for homes and businesses across Los Angeles County."
      pageTitle="Truck Wrap | Sunlight Grounds Care"
    />
  );
}
